import * as Yup from 'yup';

import { filePayloadArrayValidationSchema } from 'src/components/validation/FilePayloadArrayValidationSchema';
import { fileReferencesToFilePayloads } from 'src/helpers';
import type { IFilePayload, IFileReference } from 'src/types';

export type IVendorLeadProductImagesFormValues = {
  images: IFilePayload[];
};

export const vendorLeadProductImagesValidationSchema: Yup.ObjectSchema<
  IVendorLeadProductImagesFormValues,
  IVendorLeadProductImagesFormValues
> = Yup.object<IVendorLeadProductImagesFormValues>().shape({
  images: filePayloadArrayValidationSchema.min(0),
});

export const vendorLeadProductImagesInitialValues = (images: IFileReference[]): IVendorLeadProductImagesFormValues => ({
  images: fileReferencesToFilePayloads(images),
});
